import React from 'react';

// import UserProfile from '../../components/UserProfile';

function Users() {
  // const [user, setUser] = useState<getByIdxRes>();
  return (
    <>
      <div>유저 페이지 입니다.</div>
    </>
  );
}

export default Users;
